import { render, staticRenderFns } from "./mallitem-dialog-selector.vue?vue&type=template&id=3bcfa0e5&"
import script from "./mallitem-dialog-selector.vue?vue&type=script&lang=js&"
export * from "./mallitem-dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./mallitem-dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports